export const STATUS_INITIAL = 0
export const STATUS_SAVING = 1
export const STATUS_SUCCESS = 2
export const STATUS_FAILED = 3
